import {
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import * as React from "react";
import { useState } from "react";
import { NavHashLink } from "react-router-hash-link";
import { StyledButton } from "../helpers/button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import "../styles.css";
import "./navbar.css";
const useStyles = makeStyles({
  list: {
    width: 250
  },
  linkText: {
    textDecoration: `none`,
    textTransform: `uppercase`,
    color: `black`
  },
  button: {
    boxShadow: "0px 14px 30px #00000029",
    borderRadius: 15,
    opacity: 1,
    height: 40,
    width: 60,
    backgroundColor: "#fff",
    color: "#2498FB",
    "&:hover": {
      backgroundColor: "#fff"
    },
    "&:focus": {
      backgroundColor: "#fff"
    }
  },
  buttonCont: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
});

const SideDrawer = ({ navLinks }) => {
  const classes = useStyles();
  const [state, setState] = useState({ right: false });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ [anchor]: open });
  };

  const sideDrawerList = (anchor) => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List component="nav" className="sideDrawerListsNav">
        {navLinks.map(({ title, path }) => (
          <ListItem
            activeClassName="active"
            to={path}
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            component={NavHashLink}
            button
            onClick={toggleDrawer(anchor, false)}
          >
            <ListItemText primary={title} />
          </ListItem>
        ))}
      </List>
      <div className={classes.buttonCont}>
        <StyledButton
          maxWidth={"80%"}
          height={"40px"}
          style={{ fontSize: "1em", marginRight: 0, marginBottom: 20 }}
        >
          Get A Quote
        </StyledButton>
        <ButtonGroup
          variant="contained"
          color="primary"
          aria-label="call or Email Us"
        >
          <Button className={classes.button}>
            <i class="fa fa-phone" aria-hidden="true"></i>
          </Button>
          <Button className={classes.button}>
            <i class="fa fa-envelope" aria-hidden="true"></i>
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <IconButton
        edge="start"
        aria-label="menu"
        onClick={toggleDrawer("right", true)}
      >
        <i class="fa fa-bars" aria-hidden="true" style={{ color: "#fff" }}></i>
      </IconButton>

      <Drawer
        anchor="right"
        open={state.right}
        onOpen={toggleDrawer("right", true)}
        onClose={toggleDrawer("right", false)}
      >
        {sideDrawerList("right")}
      </Drawer>
    </React.Fragment>
  );
};

export default SideDrawer;
